import { Component, OnInit, Output, EventEmitter, Inject, PLATFORM_ID, HostListener } from '@angular/core'; 
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

import { UserService } from '@services/user.service';
import { RouteService } from '@services/route.service';
import { GlobalService } from '@services/global.service';
import { CartService } from '@services/cart.service';
import { SearchService } from '@services/search.service';
import { MenuItem } from '@models/global'; 

@Component({
  selector: 'gob-nav-head',
  templateUrl: './nav-head.component.html',
  styleUrls: ['./nav-head.component.scss']
})
export class NavHeadComponent implements OnInit {

  @Output() loading = new EventEmitter<boolean>();

  isMenuOpen: boolean = false;
  hoveredCategory: string | null = null;
  rechercheMobileOuverte: boolean = false;
  isAdmin: boolean = false;
  menu: MenuItem[] = [];

  // Gestion des menus
  activeAdminMenu: string | null = null;
  activeMobileCategory: string | null = null;

  // --- DONNÉES STATIQUES POUR LE MENU ANIMATIONS (AJOUTÉ POUR MOBILE) ---
  dataShops = [
    { label: 'Nancy', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/nancy' },
    { label: 'Metz', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/metz' },
    { label: 'Thionville', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/thionville' },
    { label: 'Pont-à-Mousson', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/pont-a-mousson' },
    { label: 'Semécourt', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/semecourt-semecourt' },
    { label: 'Toul', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/toul' }
  ];

  dataTournaments = [
    { label: 'Yu-Gi-Oh!', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/yu-gi-ho' },
    { label: 'Magic', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/magic' },
    { label: 'Pokémon', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/pokemon' },
    { label: 'RiftBound', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/riftbound' },
    { label: 'Lorcana', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/lorcana' },
    { label: 'Autres Tournois', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner/toutes' }
  ];

  dataActivities = [
    { label: 'Jeux de société', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe' },
    { label: 'Jeux de rôles', lien: 'https://lesanimationsdugobelin.com/animations/evenements/jeux-de-role' },
    { label: 'Cartes à collectionner', lien: 'https://lesanimationsdugobelin.com/animations/evenements/cartes-a-collectionner' },
    { label: 'Figurines', lien: 'https://lesanimationsdugobelin.com/animations/evenements/figurines' }
  ];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private globalService: GlobalService,
    public route: RouteService,      
    public userServ: UserService,    
    public cart: CartService,        
    public search: SearchService,    
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = activatedRoute.firstChild;
        let child = route;
        while (child) {
          if (child.firstChild) {
            child = child.firstChild;
            route = child;
          } else
            child = null;
        }
        return route;
      }),
      mergeMap(route => route ? route.data : [])
    )
    .subscribe(data => {
      this.isAdmin = (data && data.isAdmin === true);
    });
  }

  ngOnInit(): void {
    this.loading.emit(true);
    this.globalService.getMenu().subscribe(menu => {
      this.menu = menu;
      this.loading.emit(false);
    });
  }

  // --- ACTIONS ---

  toggleMobileCategory(categoryName: string, event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.activeMobileCategory === categoryName) {
      this.activeMobileCategory = null;
    } else {
      this.activeMobileCategory = categoryName;
    }
  }

  toggleAdminMenu(menuName: string, event: Event) {
    event.stopPropagation();
    if (this.activeAdminMenu === menuName) {
      this.activeAdminMenu = null;
    } else {
      this.activeAdminMenu = menuName;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.activeAdminMenu = null;
  }

  unlog() {
    this.userServ.unlog().subscribe(() => {
      this.route.navigate('login');
      this.closeMenu();
    });
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
    this.activeMobileCategory = null;
  }

  basculerRecherche() {
    this.rechercheMobileOuverte = !this.rechercheMobileOuverte;
  }

  onMouseEnter(categoryLabel: string) {
    if (categoryLabel.toLowerCase().includes('nouveaut')) {
      this.hoveredCategory = null;
      return;
    }
    const item = this.menu.find(m => m.name === categoryLabel);
    if (item && (!item.children || item.children.length === 0)) {
      this.hoveredCategory = null;
      return;
    }
    this.hoveredCategory = categoryLabel;
  }

  onMouseLeave() {
    this.hoveredCategory = null;
  }

  isUserConnected(): boolean {
    return this.userServ.isConnected(); 
  }

  getLink(item: MenuItem): any {
    let name: string = item.name
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return this.route.parse('products-list', [item.type, item.val, name]);
  }
}